export default __webpack_public_path__ + "static/media/jaguar.901d72e9.svg";